import { ATTRIB } from 'constants/test';
import { cloneElement } from 'react';
import { t } from 'services/i18n.service';
import { appsToDownload } from 'utils/download';
import Logo from 'assets/icons/Logo';

const Footer = () => {
  return (
    <section className='mx-auto flex flex-col items-center gap-4 ~py-3/6'>
      <div className='w-fit flex flex-wrap ~gap-5/10'>
        {appsToDownload.map(({ link, icon }) => (
          <div key={link} className='flex flex-col items-center ~gap-1/1.5'>
            <a
              target='_blank'
              href={link}
              rel='noreferrer'
              className='~p-1.5/2 ~rounded-md/lg shadow-sm sm:shadow-md bg-primary-400 hover-scale dark:bg-primary-dark-100 dark:hover:bg-primary-dark-200'
              data-testid='download-app-btn'>
              {cloneElement(icon, {
                styles: '~w-3.5/5 ~h-3.5/5'
              })}
            </a>
          </div>
        ))}
      </div>
      <div className='w-full h-fit flex flex-col justify-center items-center gap-1 ~text-xs/sm'>
        <p className='w-full text-gray-500 dark:text-secondary-200 text-center '>
          {t('all_rights_reserved', {
            year: new Date().getFullYear().toString()
          })}
        </p>
        <div className='w-fit flex items-center gap-1'>
          <a
            className='mr-6 text-gray-500 dark:text-secondary-200 hover:text-black dark:hover:text-secondary-100'
            href='https://www.focusbear.io/terms-of-service'
            data-testid={ATTRIB.DATA_TESTID.FOOTER_TERMS_LINK}>
            {t('terms_of_service')}
          </a>
          <a
            className='text-gray-500 dark:text-secondary-200 hover:text-black dark:hover:text-secondary-100'
            href='https://www.focusbear.io/privacy-policy'
            data-testid={ATTRIB.DATA_TESTID.FOOTER_PRIVACY_LINK}>
            {t('privacy_policy')}
          </a>
        </div>
      </div>
      <div className='flex flex-col justify-center items-center gap-1 ~text-xs/sm'>
        <Logo className='~w-20/28 object-contain' />
        <a
          className='italic'
          href='https://www.focusbear.io'
          data-testid={ATTRIB.DATA_TESTID.FOOTER_WEBSITE_LINK}>
          www.focusbear.io
        </a>
      </div>
    </section>
  );
};

export default Footer;
